import { render } from "./TamButton.vue?vue&type=template&id=6c5c5f13"
import script from "./TamButton.vue?vue&type=script&lang=js"
export * from "./TamButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__